import { 
  getPrincipiosActivosCategorias as getPActivosCategorias, 
  getPrincipioActivoCategoria as getPActivosACategoria,
  deletePrincipioActivoCategoria as deletePrincipioActivoACategoria,
  editPrincipioActivoCategoria as editPrincipioActivoACategoria,
  createPrincipioActivoCategoria as createPrincipioActivoACategoria } from "../../../helpers/backend_helper";

import {  apiError, principiosActivosCategoriasSuccess, principioActivoCategoriaSuccess, principiosActivosCategoriaDeleteSuccess, reset_principiosActivosCategoria_flag,} from "./reducer";

export const getPrincipiosActivosCat = () => async (dispatch) => {
  //console.log("THUNK -- getPrincipiosActivosCat action started");
  
  try {
    //console.log("Thunk -- getPrincipiosActivosCateg called");
    
    //console.log("Calling getPActivosCategorias");
    const response = getPActivosCategorias();

    //console.log("API response:", response);
    
    //console.log("Awaiting response");
    const data = await response;
    //console.log("Data received:", data);

    if (data) {
      //console.log("Dispatching success action");
      dispatch(principiosActivosCategoriasSuccess(data));
    }
  } catch (error) {
    console.error("Error in getPrincipiosActivosCat:", error);
    dispatch(apiError(error));
  }
};


export const deletePrincipioActivoCategoria = (id) => async (dispatch) => {
  try {
    const response = deletePrincipioActivoACategoria(id);
    const data = await response;
    if (data) {
      dispatch(principiosActivosCategoriaDeleteSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const editPrincipioActivoCategoria = (principioActivo) => async (dispatch) => {
  try {
    const response = editPrincipioActivoACategoria(principioActivo);
    const data = await response;
    if (data) {
      dispatch(principioActivoCategoriaSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const createPrincipioActivoCategoria = (principioActivo) => async (dispatch) => {
  try {
    const response = createPrincipioActivoACategoria(principioActivo);
    const data = await response;  

    if (data) {
      dispatch(principioActivoCategoriaSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const getPrincipioActivoCategoria = (id) => async (dispatch) => {
  try {
    const response = getPActivosACategoria(id);
    const data = await response;
    
    if (data) {
      dispatch(principioActivoCategoriaSuccess(data));
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetPrincipiosActivosCategoriaFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_principiosActivosCategoria_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
